<template>
  <div
    class="behaviour-settings-placeholder rounded-5 bg-white p-5 text-center"
    role="region"
    :aria-label="titleText"
    data-testid="behaviour-settings-placeholder"
  >
    <p class="text-muted mb-0">{{ emptyTabBody }}</p>
  </div>
</template>

<script>
import { computed } from "vue"
import { useRoute } from "vue-router"
import { useStore } from "vuex"

export default {
  name: "BehaviourSettingsPlaceholderTab",
  setup() {
    const store = useStore()
    const route = useRoute()

    const behaviourTerminology = computed(
      () => store.getters["behaviourSettings/behaviourTerminology"]
    )

    const titleText = computed(() => {
      const field = route.meta?.behaviourPlaceholderTerminologyKey
      const bt = behaviourTerminology.value
      if (field && bt?.[field]) {
        return bt[field]
      }
      return bt.emptyTabTitle
    })

    const emptyTabBody = computed(() => behaviourTerminology.value.emptyTabBody)

    return {
      titleText,
      emptyTabBody
    }
  }
}
</script>
